/**
 * Decode HTML entities.
 *
 * @param {string} html - The HTML string to decode.
 * @returns {string} The decoded string.
 */
export function decode_html_entities(html) {
  var element = document.createElement('div');
  element.innerHTML = html; // Assign the HTML string with entities
  return element.textContent || element.innerText; // Get the decoded text
}
